<template>
<v-container fluid :style="{ backgroundColor: '#ffffff'}">
    <GeneralWorkflowDetail v-if="screen_data" :screen_data="screen_data"
        :staff_or_loginas="staff_mode"
        :show_next="showNext"
        :show_prev="showPrev"
        @approve="approve"
        @reject="reject"
        @save-comments="saveComments"
        @continueWorkflow="continueWorkflow"
        @next="nextDoc"
        @prev="prevDoc"
        @download="downloadPDF"
        >
        <template #custom-content>
            <v-row v-if="im_staff_or_loginas">
                <v-col cols="1">
                </v-col>
                <v-col  cols="3">
                    <div>
                        <v-btn @click="staff_mode = !staff_mode" small :color="staff_mode?'cyan':'orange'"> {{staff_mode?"VISTA CLIENTE":"VISTA STAFF"}} </v-btn>
                    </div>
                </v-col>
                <v-col  cols="3" v-if="staff_mode && screen_data.document.rendered_text">
                    <div>
                        <v-btn @click="copy_lmdx" small> COPY LMDX </v-btn>
                    </div>
                </v-col>
                <v-col  cols="3" v-if="staff_mode">
                    <div>
                        <v-btn @click="download_cropped_pdf" small> DOWNLOAD CROPPED </v-btn>
                    </div>
                </v-col>
                
            </v-row>
        </template>
        </GeneralWorkflowDetail>
    <ExtractedDataComponent :key="'ex'+screen_data.document.id.toString()" v-if="screen_data.document && screen_data.document.context_data"  
        :data="screen_data.document.context_data">   
    </ExtractedDataComponent>

    <ExtractedDataComponent :key="'at'+screen_data.document.id.toString()" v-if="screen_data.document && screen_data.document.hidden_context_data && staff_mode"   
        :data="screen_data.document.hidden_context_data" :title="'Registros adjuntados'">   
    </ExtractedDataComponent>
    
    
    <div v-if="staff_mode && screen_data.document && screen_data.document.running_info">
        Running info:
        {{ screen_data.document.running_info }}
    </div>
    <div v-if="staff_mode && screen_data.document && screen_data.document.errors">
        Errors:
        {{ screen_data.document.errors }}
    </div>
</v-container>
</template>

<script>
import { VueOtherDocumentScreenData } from '@/modules/document/infra/VueOtherDocumentScreenData';
import { mapGetters, mapState } from "vuex";
import {OtherDocDetailComponent} from '../modules/document/application/OtherDocDetailComponent'
import {ApiOtherDocumentRepository} from '../modules/document/infra/ApiOtherDocumentRepository'
import GeneralWorkflowDetail from '@/modules/document/infra/GeneralWorkflowDetail.vue'
import ExtractedDataComponent from '@/modules/document/infra/ExtractedDataComponent.vue'
import { document_components_factory } from "@/api/client";

export default {
    name: 'OtherDocWorkflowDetail',
    components: {
        GeneralWorkflowDetail,
        ExtractedDataComponent
    },
    data() {
        return {
            other_doc_detail_component:null,
            bottomSheet: false,
            staff_mode: false,
        }
    },
    props: {
        screen_data:{
            type: [Object],
            required: true,
            default: null
        },
        list_component:{
            required: true,
            default: null
        },
        other_document_id:{
            type: [Number,String],
            required: true,
            default: null
        },
        companydb_id:{
            type: [Number,String],
            required: false,
            default: null
        },
    },
    async mounted() {
        this.other_doc_detail_component = new OtherDocDetailComponent(new ApiOtherDocumentRepository(), this.screen_data)
        await this.other_doc_detail_component.get_document_url(this.other_document_id)
        await this.other_doc_detail_component.find_by_id(this.other_document_id)
    },
    methods: {
        uuid_or_id_from_doc(doc){
            if (!doc) return null
            return doc.uuid || doc.id
        },
        toggleDrawer() {
            this.bottomSheet = !this.bottomSheet
        },
        async approve(){
            await this.other_doc_detail_component.aproveDocument(this.screen_data.document.id)
        },
        async reject(){
            await this.other_doc_detail_component.rejectDocument(this.screen_data.document.id)
        },
        async saveComments(){
            await this.other_doc_detail_component.saveDocumentComments(this.screen_data.document.id, this.screen_data.document.comments)
        },
        async continueWorkflow(){
            await this.other_doc_detail_component.continueWorkflow(this.screen_data.document.id)
        },
        async nextDoc(){
            console.log(this.next_and_previous_document.previous === null , this.there_are_more_pages)
            if(this.next_and_previous_document.next === null && this.there_are_more_pages){
                this.list_component.screen_data.offset += this.list_component.screen_data.limit
                this.list_component.screen_data.currentPage += 1
                await this.list_component.searchDocuments(this.companydb_id)
                let next_id =this.uuid_or_id_from_doc( this.list_component.screen_data.other_documents[0])
                await this.changeDocument(next_id)
                console.log(this.next_and_previous_document)
            }
            else if (this.next_and_previous_document.next){
                await this.changeDocument(this.next_and_previous_document.next)
            }
        },
        async prevDoc(){
            if(this.next_and_previous_document.previous === null && this.im_not_in_first_page){
                this.list_component.screen_data.offset -= this.list_component.screen_data.limit
                this.list_component.screen_data.currentPage -= 1
                await this.list_component.searchDocuments(this.companydb_id)
                let prev_id = this.uuid_or_id_from_doc(this.list_component.screen_data.other_documents[this.list_component.screen_data.other_documents.length-1])
                await this.changeDocument(prev_id)
            }
            else if (this.next_and_previous_document.previous){
                await this.changeDocument(this.next_and_previous_document.previous)
            }
        },
        async changeDocument(id){
            this.$router.push({name: 'other-doc-detail', params: {other_document_id: id}})
            await this.other_doc_detail_component.get_document_url(id)
            await this.other_doc_detail_component.find_by_id(id)
        },
        copy_lmdx(){
            let lmdx = this.screen_data.document.rendered_text

            if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
                // ✅ Modern approach using Clipboard API
                navigator.clipboard.writeText(lmdx)
                    .then(() => console.log("Schema copied successfully!"))
                    .catch(err => {
                        console.error("Failed to copy schema:", err);
                        alert("Failed to copy. Please try again.");
                    });
            } else {
                // 🚀 Safe fallback without using `execCommand`
                const textArea = document.createElement("textarea");
                textArea.value = lmdx;
                textArea.style.position = "fixed"; // Prevent scrolling
                textArea.style.opacity = "0"; // Hide it visually
                document.body.appendChild(textArea);
                textArea.select();
                
                try {
                    const successful = document.execCommand("copy"); // Works in older browsers
                    console.log("Copied using fallback method:", successful); // ( a mi em va per aquí de fet)
                } catch (err) {
                    console.error("Fallback copy failed:", err);
                    alert("Clipboard copy not supported in your browser.");
                }

                document.body.removeChild(textArea);
            }
        },
        async downloadPDF(){
            this.other_doc_detail_component.downloadPDF(this.other_document_id)
        },
        async download_cropped_pdf(){
            this.other_doc_detail_component.downloadCroppedPDF(this.other_document_id)
        },
    },
    computed: {
        ...mapState(['search_state', 'tags', 'currentCompany', 'session_information']),
        ...mapGetters([
            "is_mobile",
        ]),
        ...mapGetters({
            userData: 'me/userData',
        }),
        im_staff_or_loginas() {
            return (this.userData && this.userData.is_staff) || (this.session_information && this.userData.username && this.session_information.username != this.userData.username )
        },
        next_and_previous_document(){
            let next = null
            let previous = null
            if(this.list_component && this.list_component.screen_data && this.list_component.screen_data.other_documents && this.other_doc_detail_component && this.other_doc_detail_component.screen_data.document){
                let index = this.list_component.screen_data.other_documents.findIndex(doc => this.uuid_or_id_from_doc(doc) == this.uuid_or_id_from_doc(this.other_doc_detail_component.screen_data.document))
                if(index >= 0){
                    let next_i =index+1
                    let previous_i = index-1
                    if(next_i < this.list_component.screen_data.other_documents.length){
                        next = this.uuid_or_id_from_doc(this.list_component.screen_data.other_documents[next_i])
                    }   
                    if(previous_i >= 0){
                        previous = this.uuid_or_id_from_doc(this.list_component.screen_data.other_documents[previous_i])
                    }

                }
            }
            return {next,previous}
        },
        im_not_in_first_page(){
            return this.list_component && this.list_component.screen_data && this.list_component.screen_data.offset > 0
        },
        there_are_more_pages(){
            return this.list_component && this.list_component.screen_data && this.list_component.screen_data.offset + this.list_component.screen_data.limit < this.list_component.screen_data.totalItems
        },
        showPrev(){
            return this.next_and_previous_document.previous !== null || this.im_not_in_first_page
        },
        showNext(){
            return this.next_and_previous_document.next !== null || this.there_are_more_pages
        }
    }

}

</script>